import styled, { css } from 'styled-components';
import { fillAbsolute, secondaryAnimatedPlaceholder } from '../../../../theme/mixins';
import { LazyLoadImage } from '../../../../shared/components/lazyLoadImage';

export const Image = styled(LazyLoadImage).attrs(() => ({
  imgStyle: css`
    ${fillAbsolute};
    object-fit: cover;
  `,
  placeholderStyle: css`
    height: 100%;
    ${secondaryAnimatedPlaceholder};
  `,
}))`
  ${fillAbsolute};
  object-fit: cover;
`;
